export default {
  // Form Title & Actions
  createPetProfile: "ペットプロフィール作成",
  editPet: "ペット編集",
  back: "戻る",
  previous: "前へ",
  next: "次へ",
  complete: "完了して保存",
  saving: "保存中...",
  saved: "保存完了！",
  autoSaved: "自動保存",
  saveProgress: "進捗を保存",
  autoSaveEnabled: "自動保存有効",
  saveFailed: "保存失敗",
  saveDataError: "データ保存失敗",
  retry: "再試行",
  close: "閉じる",
  cancel: "キャンセル",
  ok: "OK",
  
  // Steps
  step: "ステップ",
  basicDetails: "基本情報",
  physicalTraits: "外見特徴",
  careNeeds: "ケア要件",
  healthRecords: "健康記録",
  review: "確認と完了",
  
  // Tips & Help
  showTips: "ヒントを表示",
  hideTips: "ヒントを非表示",
  preview: "プレビュー",
  backToEditMode: "編集モードに戻る",
  tagOperationHint: "Enterまたはカンマでタグを追加、複数項目を貼り付けると自動分割",
  
  // Basic Info
  basicInfoTips: "基本情報から始めましょう - ペットの名前、種類、基本情報",
  petPhoto: "ペット写真",
  uploading: "アップロード中...",
  enterPetName: "ペットの名前を入力",
  name: "名前",
  nameRequired: "名前は必須です",
  nameHelpText: "例: ポチ、タマ、モモ、チョコ",
  type: "ペットタイプ",
  typeRequired: "ペットタイプは必須です",
  breed: "品種",
  specificBreed: "例: ゴールデンレトリバー、ペルシャ猫",
  breedHelpText: "例: 柴犬、ラブラドール、シャム猫、メインクーン、セキセイインコ",
  birthDate: "誕生日",
  yearLabel: "年",
  monthLabel: "月",
  dayLabel: "日",
  selectYear: "年",
  selectMonth: "月",
  selectDay: "日",
  currentAge: "現在の年齢",
  age: "年齢",
  birthDateCannotBeFuture: "誕生日は未来にできません",
  birthDateTooOld: "誕生日が古すぎます（最大{maxAge}年）",
  gender: "性別",
  genderHelpText: "ペットの性別を選択",
  male: "オス",
  female: "メス",
  notSpecified: "未指定",
  microchipId: "マイクロチップID",
  enterMicrochipId: "マイクロチップ番号を入力",
  microchipHelpText: "例: 982000123456789（15桁の番号）",
  registrationId: "登録番号",
  registrationIdHelpText: "例: 政府登録番号、ペット協会会員ID",
  currentLocation: "現在地",
  currentLocationHelpText: "例: 自宅、友人宅、ペットホテル、動物病院",
  
  // Pet Type Descriptions
  dog: "犬",
  cat: "猫",
  bird: "鳥",
  fish: "魚",
  rabbit: "ウサギ",
  hamster: "ハムスター",
  guinea_pig: "モルモット",
  reptile: "爬虫類",
  turtle: "カメ",
  other: "その他",
  
  // Physical Traits
  physicalCharacteristicsDesc: "健康追跡のためにペットの身体的特徴を記録",
  weight: "体重",
  enterWeight: "例: 15 kg",
  weightHelpText: "定期的な体重測定は健康管理に役立ちます",
  height: "身長",
  enterHeight: "例: 45 cm",
  heightHelpText: "肩高を測定（地面から肩までの高さ）",
  color: "毛色",
  colorExample: "例: ゴールド、白黒",
  colorHint: "例: ゴールド、茶色、黒、白、灰色、斑点、縞模様、三毛",
  coatType: "被毛タイプ",
  coatTypeHint: "例: 短毛、長毛、巻き毛、シルキー、ワイヤー、ダブルコート、無毛",
  eyeColor: "目の色",
  eyeColorHint: "例: 茶色、青、緑、琥珀色、ヘーゼル、オッドアイ（異色瞳）",
  bodySize: "体格",
  bodySizeHint: "例: 超小型、小型、中型、大型、超大型",
  specialMarkings: "特別なマーキング",
  specialMarkingsHint: "例: 胸の白い斑点、黒い耳先、ハート型の斑点、左足の傷跡",
  
  // Care Needs
  dietaryTips: "給餌スケジュールとケア要件を設定",
  dietaryInfo: "食事情報",
  feedingSchedule: "給餌スケジュール",
  addMeal: "食事を追加",
  time: "時間",
  timeHint: "給餌時間を設定、例: 午前8時、午後6時",
  portionSize: "分量",
  portionSizeExample: "例: 1カップ",
  portionSizeHint: "分量を記録、例: 1カップ、200g、半碗、大さじ2",
  foodType: "食品タイプ",
  foodTypeHint: "食品カテゴリを記録、例: ドライフード、ウェットフード、生食、おやつ",
  noMealsAdded: "まだ食事が追加されていません。「食事を追加」をクリックして開始。",
  canEat: "食べられる",
  canEatHelpText: "ペットに安全な食品をリスト",
  canEatHint: "例: 鶏肉、牛肉、かぼちゃ、さつまいも、ブルーベリー、リンゴ（種なし）、にんじん",
  cannotEat: "食べられない",
  cannotEatHelpText: "ペットが避けるべき食品をリスト",
  cannotEatHint: "例: チョコレート、玉ねぎ、ブドウ、アボカド、キシリトール、コーヒー、にんにく",
  
  behaviorInfo: "行動情報",
  likes: "好き",
  whatPetEnjoys: "ペットは何を楽しみますか？",
  likesHint: "例: ボール遊び、水泳、追いかけっこ、猫じゃらし、日光浴、お腹なで",
  dislikes: "嫌い",
  whatMakesPetUncomfortable: "ペットを不快にするものは？",
  dislikesHint: "例: お風呂、爪切り、ドライヤー、知らない人、他の動物、雷",
  temperament: "気質",
  temperamentExample: "例: フレンドリー、シャイ、活発",
  temperamentHint: "例: フレンドリー、温和、遊び好き、シャイ、独立的、甘えん坊、活発、穏やか",
  exerciseNeeds: "運動ニーズ",
  exerciseExample: "例: 毎日30分の散歩",
  exerciseNeedsHint: "例: 毎日散歩、走るスペースが必要、水泳が好き、アパート向き",
  
  // Health Records
  healthTips: "薬と健康情報を追跡",
  healthInfo: "健康情報",
  medicationSchedule: "投薬スケジュール",
  addMedication: "薬を追加",
  medicationName: "薬名",
  medicationPlaceholder: "例: 抗生物質",
  medicationNameHint: "薬名を入力、例: フィラリア予防薬、抗生物質、関節サプリメント",
  dosage: "用量",
  dosagePlaceholder: "例: 10mg",
  dosageHint: "用量を記録、例: 10mg、1錠、5ml、半錠",
  frequency: "頻度",
  frequencyHint: "投薬頻度を選択: 毎日、1日2回、毎週、またはカスタム",
  daily: "毎日",
  twiceDaily: "1日2回（BID）",
  thriceDaily: "1日3回（TID）",
  weekly: "毎週",
  monthly: "毎月",
  custom: "カスタム",
  dosageTimes: "投薬時間",
  dosageTimesHint: "具体的な投薬時間を設定、例: 午前8時、午後8時",
  addTime: "時間を追加",
  noMedicationsAdded: "まだ薬が追加されていません。「薬を追加」をクリックして開始。",
  
  vaccines: "ワクチン",
  vaccinesHelpText: "すべてのワクチンと日付をリスト",
  vaccinesHint: "例: 狂犬病、混合ワクチン、ボルデテラ、ライム病、猫三種混合",
  nextVetVisit: "次回獣医訪問",
  nextVetVisitHelp: "次回の獣医予約をスケジュール",
  allergies: "アレルギー",
  knownAllergies: "既知のアレルギーをリスト",
  allergiesHint: "例: 花粉、ほこり、鶏肉、牛肉、ノミ、特定の薬",
  medicalConditions: "医療状態",
  chronicConditions: "慢性疾患はありますか？",
  medicalConditionsHint: "例: 心臓病、糖尿病、関節炎、腎臓病、てんかん、甲状腺問題",
  
  veterinarianInfo: "獣医情報",
  vetName: "獣医名",
  yourPetsVet: "ペットの獣医名",
  vetNameHint: "例: 市立動物病院、スミス先生のクリニック、ハッピーペット獣医",
  vetPhone: "獣医電話",
  emergencyContactPhone: "緊急連絡番号",
  vetPhoneHint: "例: 03-1234-5678、090-1234-5678",
  vetAddress: "獣医住所",
  enterVetAddress: "クリニックの住所を入力",
  vetAddressHint: "例: 東京都渋谷区渋谷1-2-3、大阪市北区梅田4-5-6",
  vetEmail: "獣医メール",
  enterVetEmail: "獣医のメールを入力",
  vetEmailHint: "例: clinic@example.com、drsmith@vet.jp",
  insuranceProvider: "保険会社",
  insuranceProviderHint: "例: アニコム損保、アイペット、ペッツベスト",
  insurancePolicy: "保険証券番号",
  insurancePolicyHint: "例: PET2024001234、INS-20240101-001",
  
  specialNotes: "特記事項",
  additionalInfo: "追加情報",
  specialNotesHint: "例: 雷が怖い、特定の音に敏感、特別なケア要件、行動リマインダー",
  
  // Review
  reviewDescription: "保存前にすべての情報を確認",
  profileCompletion: "プロフィール完成度",
  excellent: "優秀",
  good: "良好",
  minimal: "最小限",
  completeReviewTitle: "完全プロフィールレビュー",
  completeProfilePreview: "完全プロフィールプレビュー",
  unnamedPet: "名前未設定のペット",
  notFilled: "未記入",
  editData: "データ編集",
  
  // Save & Share
  enterNameToSave: "ペット名を入力して保存を有効化",
  fillBasicInfoToSave: "基本情報を入力して保存",
  petUpdatedSuccessfully: "ペット更新成功！",
  petSavedSuccessfully: "ペット保存成功！",
  nowYouCanShare: "ペットプロフィールを他の人と共有する準備ができました",
  shareNow: "今すぐ共有",
  backToDashboard: "ダッシュボードに戻る",
  continueEditing: "編集を続ける",
  errorOccurred: "エラー発生",
  fixFormErrors: "フォームエラーを修正してください",
  pleaseCheckAndFixErrors: "フォームのエラーを確認して修正してください",
  saveBeforeShare: "共有前に保存",
  needToSaveBeforeSharing: "共有する前にペットプロフィールを保存する必要があります",
  saveAndShare: "保存して共有",
  
  // Upload
  invalidFileType: "無効なファイルタイプ。画像をアップロードしてください。",
  fileTooLarge: "ファイルが大きすぎます。最大サイズは5MBです。",
  imageStoredLocally: "画像をローカルに保存しました",
  imageUploadedSuccessfully: "画像アップロード成功！",
  imageStoredAsBase64: "画像をBase64として保存しました",
  
  // Tag Input
  tagHint: "Enterまたはカンマで追加",
  
  // Time units
  year: "年",
  years: "年",
  month: "ヶ月",
  months: "ヶ月",
  unknown: "不明"
};